import HelpButton from "@/components/HelpButton/HelpButton";
import NoImpactBanner from "@/components/NoImpactBanner/NoImpactBanner";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import { useCompanyAccess } from "@/hooks/useCompanySettings";
import styles from "@/pages/dashboard/Dashboard.module.scss";
import { Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import MetricSelector from "../components/MetricSelector/MetricSelector";
import YearPicker from "../components/YearPicker/YearPicker";
import { useDashboardYear } from "../hooks/useDateRange";
import { useFacilityImpactTotals } from "../hooks/useFacilityImpact";
import useImpactMetric from "../hooks/useImpactMetric";
import FacilityImpactPerScope from "./widgets/FacilityImpactPerScope";
import FacilityImpactPerType from "./widgets/FacilityImpactPerType";
import FacilityImpactSideBySide from "./widgets/FacilityImpactSideBySide/FacilityImpactSideBySide";
import FacilityImpactTopContributors from "./widgets/FacilityImpactTopContributors";
import FacilityImpactTotal from "./widgets/FacilityImpactTotal";
import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";

export default function FacilityDashboard() {
  const metric = useImpactMetric();
  const navigate = useNavigate();
  const access = useCompanyAccess();

  const { data: totalImpact } = useFacilityImpactTotals({ metrics: [metric.key] });
  const { year } = useDashboardYear();
  const pageTitle = `Facility impact`;
  const pageDescription =
    "Insight into the part of your total company impact attributed to facilities.";

  if (access && !access.includes("lca"))
    return (
      <PremiumExplore
        title={pageTitle}
        description={pageDescription}
      />
    );

  return (
    <div>
      <PageHeader
        title={pageTitle}
        description={pageDescription}
        right={
          <>
            <YearPicker />
            <HelpButton url="https://help.root-sustainability.com/en/articles/9899046-facility-impact-dashboard" />
          </>
        }
      />
      <MetricSelector
        value={metric.key}
        onChange={(key) => navigate("/dashboard/facility/" + key)}
      />
      {totalImpact?.utility_impact[metric.key] === 0 ? (
        <NoImpactBanner title={`No facility impact for ${year}`}>
          <span>
            Upload utility contracts for this year to get insights into facility emissions.
          </span>
          <Link to="/facilities">
            <Button type="primary">Go to facilities</Button>
          </Link>
        </NoImpactBanner>
      ) : (
        <div className={styles.grid}>
          <div className={styles["two-columns"]}>
            <div>
              <FacilityImpactTotal metric={metric} />
              <FacilityImpactPerType metric={metric} />
              {metric.key === "carbon_footprint" && <FacilityImpactPerScope />}
            </div>
            <div>
              <FacilityImpactTopContributors metric={metric} />
            </div>
          </div>
          <div className={styles["one-column"]}>
            <FacilityImpactSideBySide metric={metric} />
          </div>
        </div>
      )}
    </div>
  );
}
